import { useState, type MouseEvent, type PointerEvent } from "react";
import { HoverTip, closeAllHoverTips } from "~/components/blocks/common/HoverTip";
import SvgWrapper from "~/lib/utils/SvgWrapper";
import TruCheckModal from "../Modals/TruCheck/Desktop";
import { formatDate } from "~/lib/helpers/dateFormatHelper";

export default function TrueCheckWithToolTip({
  date,
  isAvailable,
  isCard,
  isMapCard,
}: {
  date: Date | string | undefined;
  isAvailable: boolean;
  isCard?: boolean;
  isMapCard?: boolean;
}) {
  const [trueCheck, setTrueCheck] = useState(false);

  const stopParentNavigation = (event: PointerEvent<HTMLElement>) => {
    event.stopPropagation();
  };

  const openModal = (event: MouseEvent<HTMLButtonElement>) => {
    // Prevent the card's click/navigation handler
    event.stopPropagation();

    closeAllHoverTips();
    setTrueCheck(true);
  };

  const tooltip = date
    ? `Price verified on ${formatDate(date, "D MMMM YYYY")}`
    : null;

  return (
    <>
      <div className="relative z-[11] inline-flex shrink-0 pointer-events-auto">
        <HoverTip
          content={tooltip}
          maxWidthClass={isMapCard ? "max-w-[220px]" : "max-w-sm"}
        >
          {isCard ? (
            <button
              type="button"
              className="ml-0.5 inline-flex h-[1.5em] w-[1.5em] shrink-0 items-center justify-center pointer-events-auto"
              onPointerDown={stopParentNavigation}
              onClick={openModal}
              aria-label="View price verification details"
            >
              <img
                src={`${process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES}/assets/icons/tick.png`}
                alt="tick_mark"
                className="h-[1.1em] w-[1.1em] object-cover"
                width={20}
                height={20}
              />
            </button>
          ) : (
            <button
              type="button"
              onPointerDown={stopParentNavigation}
              onClick={openModal}
              className="rounded-full bg-white pl-1.5 pr-4 py-1 text-base w-max-content font-medium text-oh-dark-gray border border-1 flex items-center justify-center gap-2 pointer-events-auto"
            >
              <SvgWrapper
                urlEndPoint={process.env.PUBLIC_REMIX_APP_ASSETS_IMAGES}
                src="/assets/icons/verified.svg"
                stroke="white"
                height="20px"
                width="20px"
                strokeWidth="1.5"
              />
              <span className="text-xs">Verified Price</span>
            </button>
          )}
        </HoverTip>
      </div>

      {isAvailable && date && (
        <TruCheckModal visible={trueCheck} setVisible={setTrueCheck} date={date} />
      )}
    </>
  );
}
